import type { SearchSort, SearchSortField } from 'lib-search-types';
import type { SortBy } from 'lib-shared-legacy-types';

import { getSortObjectFromString } from 'utils/url/getSortObjectFromString';

const sortFields: readonly SearchSortField<'conversations'>[] = [
  'created_at',
  'last_message_created_at',
  'updated_at',
];

/** Converts a sort object to a URL-friendly string. */
export function convertSortObjectToString(
  sort?: SearchSort<'conversations'>,
): SortBy<SearchSortField<'conversations'>> | '' {
  return sort ? `${sort.field}:${sort.order}` : '';
}

/** Converts a URL-friendly string to a sort object. */
export function convertSortStringToObject(
  sort?: string,
): SearchSort<'conversations'> | undefined {
  if (!sort) return undefined;

  const sortObject = getSortObjectFromString(sort, sortFields);

  if (sortObject && sortObject.direction) {
    return { field: sortObject.key, order: sortObject.direction };
  }
}
